/* =====================================================================
   ROVEO Halo Wand PDP — vanilla JS (no dependencies)
   ===================================================================== */

(function () {
  'use strict';

  if (window.__pdpRoveoLoaded) return;
  window.__pdpRoveoLoaded = true;

  /* ── Helpers ── */
  function getSelectedOptions() {
    var opts = [];
    document.querySelectorAll('[data-pdp-option-index]').forEach(function (fs) {
      var radio = fs.querySelector('input[type="radio"]:checked');
      if (radio) { opts.push(radio.value); return; }
      var sel = fs.querySelector('select');
      if (sel) opts.push(sel.value);
    });
    return opts;
  }

  function findVariant(selectedOptions) {
    var variants = window.__pdpVariants || [];
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (v.options.every(function (o, idx) { return o === selectedOptions[idx]; })) return v;
    }
    return null;
  }

  function formatMoney(cents) {
    var n = (parseInt(cents, 10) / 100).toFixed(2);
    return '$' + n.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function showGalleryMedia(idx) {
    if (idx === null || idx === undefined) return;
    var gallery = document.querySelector('[data-pdp-gallery]');
    if (!gallery) return;
    var target = String(idx);
    var found = false;
    gallery.querySelectorAll('.pdp-gallery__media').forEach(function (m) {
      var active = m.getAttribute('data-idx') === target;
      m.classList.toggle('is-active', active);
      if (active) found = true;
    });
    if (!found) return;
    gallery.querySelectorAll('.pdp-gallery__thumb').forEach(function (t) {
      t.classList.toggle('is-active', t.getAttribute('data-idx') === target);
    });
  }

  function applyVariant(variant) {
    if (!variant) return;

    /* 1 — hidden ID input (drives cart submission) */
    var hidden = document.querySelector('[data-pdp-variant-input]');
    if (hidden) hidden.value = variant.id;

    /* 2 — price */
    var priceEl = document.querySelector('[data-pdp-price]');
    if (priceEl) priceEl.textContent = formatMoney(variant.price);

    /* 3 — compare-at + save badge */
    var compareEl = document.querySelector('[data-pdp-compare]');
    var saveEl    = document.querySelector('[data-pdp-save]');
    if (variant.compare_at_price > variant.price) {
      if (compareEl) { compareEl.textContent = formatMoney(variant.compare_at_price); compareEl.style.display = ''; }
      if (saveEl) {
        var pct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
        saveEl.textContent = 'Save ' + pct + '%';
        saveEl.style.display = '';
      }
    } else {
      if (compareEl) compareEl.style.display = 'none';
      if (saveEl)    saveEl.style.display    = 'none';
    }

    /* 4 — gallery — jump to the variant's featured image */
    showGalleryMedia(variant.media_idx);

    /* 5 — Shop Now button variant id */
    var shopNowBtn = document.querySelector('[data-pdp-shopnow]');
    if (shopNowBtn) {
      shopNowBtn.setAttribute('data-variant-id', variant.id);
      shopNowBtn.disabled = !variant.available;
    }

    /* 6 — ATC button (if present) */
    var atcBtn = document.querySelector('[data-pdp-atc]');
    if (atcBtn) {
      atcBtn.disabled = !variant.available;
      var labelEl = atcBtn.querySelector('[data-pdp-atc-label]');
      if (variant.available) {
        if (labelEl) labelEl.style.display = '';
        var soEl = atcBtn.querySelector('[data-pdp-soldout]');
        if (soEl) soEl.remove();
      } else {
        if (labelEl) labelEl.style.display = 'none';
        if (!atcBtn.querySelector('[data-pdp-soldout]')) {
          var so = document.createElement('span');
          so.setAttribute('data-pdp-soldout', '');
          so.textContent = 'Sold out';
          atcBtn.appendChild(so);
        }
      }
    }

    /* 7 — URL (no reload) */
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({ variantId: variant.id }, '', url.toString());
    } catch (e) {}
  }

  /* ── Swatch click (radio change) ── */
  document.addEventListener('change', function (event) {
    var input = event.target.closest('.pdp-swatch input[type="radio"]');
    if (!input) return;
    var group = input.closest('.pdp-opt__swatches');
    if (!group) return;

    /* visual active state */
    group.querySelectorAll('.pdp-swatch').forEach(function (s) { s.classList.remove('is-active'); });
    var lbl = input.closest('.pdp-swatch');
    if (lbl) lbl.classList.add('is-active');

    /* update selected-value label */
    var fieldset  = group.closest('[data-pdp-option-index]');
    var valueOut  = fieldset ? fieldset.querySelector('.pdp-opt__value') : null;
    if (valueOut) valueOut.textContent = input.value;

    /* apply variant */
    applyVariant(findVariant(getSelectedOptions()));
  });

  /* ── Select change ── */
  document.addEventListener('change', function (event) {
    var sel = event.target.closest('.pdp-opt__select');
    if (!sel) return;
    var fieldset = sel.closest('[data-pdp-option-index]');
    var valueOut = fieldset ? fieldset.querySelector('.pdp-opt__value') : null;
    if (valueOut) valueOut.textContent = sel.value;
    applyVariant(findVariant(getSelectedOptions()));
  });

  /* ── FAQ accordion ── */
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('.pdp-faq__q');
    if (!trigger) return;
    var item = trigger.closest('.pdp-faq__item');
    if (!item) return;
    var open = item.classList.toggle('is-open');
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ── Gallery thumbs ── */
  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('.pdp-gallery__thumb');
    if (!thumb) return;
    var gallery = thumb.closest('[data-pdp-gallery]');
    if (!gallery) return;
    var idx = thumb.getAttribute('data-idx');
    gallery.querySelectorAll('.pdp-gallery__thumb').forEach(function (t) { t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
    gallery.querySelectorAll('.pdp-gallery__media').forEach(function (m) {
      m.classList.toggle('is-active', m.getAttribute('data-idx') === idx);
    });
  });

  /* ── Selling plan toggle ── */
  document.addEventListener('click', function (event) {
    var plan = event.target.closest('.pdp-plan');
    if (!plan) return;
    var group = plan.closest('.pdp-plans');
    if (!group) return;
    group.querySelectorAll('.pdp-plan').forEach(function (p) { p.classList.remove('is-active'); });
    plan.classList.add('is-active');
    var input = plan.querySelector('input[type="radio"]');
    if (input) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
  });

  /* ── Quantity stepper ── */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-pdp-qty]');
    if (!btn) return;
    var action = btn.getAttribute('data-pdp-qty');
    var input  = btn.parentElement.querySelector('input[type="number"]');
    if (!input) return;
    var current = parseInt(input.value, 10) || 1;
    var min     = parseInt(input.min, 10)   || 1;
    if (action === 'inc') input.value = current + 1;
    if (action === 'dec') input.value = Math.max(min, current - 1);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ── Sticky mobile ATC ── */
  function refreshStickyAtc() {
    var bar = document.querySelector('.pdp-sticky');
    if (!bar) return;
    var threshold = parseInt(bar.getAttribute('data-show-after'), 10) || 700;
    bar.classList.toggle('is-visible', window.scrollY > threshold);
    document.body.classList.toggle('pdp-sticky-active', window.scrollY > threshold);
  }
  window.addEventListener('scroll', refreshStickyAtc, { passive: true });
  document.addEventListener('DOMContentLoaded', refreshStickyAtc);
  document.addEventListener('shopify:section:load', refreshStickyAtc);
  document.addEventListener('shopify:section:unload', refreshStickyAtc);
})();
